import { render, staticRenderFns } from "./ImportDataAlert.vue?vue&type=template&id=74102489&scoped=true"
import script from "./ImportDataAlert.vue?vue&type=script&lang=js"
export * from "./ImportDataAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74102489",
  null
  
)

export default component.exports